{
    "(save {highestYearlyDiscount}%)": "(Sutaupyk {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} d. nemokamai",
    "{amount} off": "{amount} mažiau",
    "{amount} off for first {number} months.": "{amount} pigiau pirmiems {number} mėnesiams.",
    "{amount} off for first {period}.": "{amount} pigiau pirmam {period}",
    "{amount} off forever.": "{amount} mažiau visam laikui.",
    "{discount}% discount": "{discount}% nuolaida",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "Į {memberEmail} nuo šiol nebebus siunčiamas {newsletterName} naujienlaiškis.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "Į {memberEmail} nuo šiol nebebus siunčiami pranešimai apie naujus atsakymus į jūsų komentarą.",
    "{memberEmail} will no longer receive this newsletter.": "Į {memberEmail} nuo šiol nebebus siunčiamas naujienlaiškis.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} d. nemokamai",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Paskyra",
    "Account details updated successfully": "",
    "Account settings": "Paskyros nustatymai",
    "Add a personal note": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Pasibaigus nemokamam bandomajam laikotarpiui, bus nuskaičiuota įprasta pasirinkto prenumeratos tipo kaina. Bet kuriuo metu galite atšaukti prenumeratą.",
    "Already a member?": "Jau turite paskyrą?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Įvyko klaida. Bandykite dar kartą arba <a>susisiekite su palaikymo komanda</a>, jei klaida išlieka.",
    "Back": "Atgal",
    "Back to Log in": "Sugrįžti į prisijungimą",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Juodasis penktadienis",
    "Bluesky": "",
    "Cancel anytime.": "Atšaukite bet kuriuo metu.",
    "Cancel subscription": "Atšaukti prenumeratą",
    "Canceled": "",
    "Cancellation reason": "Prenumeratos atšaukimo priežastis",
    "Change": "Pakeisti",
    "Change plan": "",
    "Check spam & promotions folders": "Patikrinkite šlamšto (spam) ir reklamos aplankus",
    "Check with your mail provider": "Pasitarkite su savo el. pašto paslaugų teikėju",
    "Check your inbox to verify email update": "",
    "Choose": "Pasirinkite",
    "Choose a different plan": "Pasirinkite kitą planą",
    "Choose a plan": "",
    "Choose your newsletters": "Pasirinkite norimus naujienlaiškius",
    "Click here to retry": "Spauskite čia, kad pakartotumėte",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Uždaryti",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Komentarai",
    "Complimentary": "Nemokamas",
    "Confirm": "Patvirtinti",
    "Confirm cancellation": "Patvirtinti atšaukimą",
    "Confirm subscription": "Patvirtinti prenumeratą",
    "Contact support": "Susisiekti su pagalba",
    "Continue": "Tęsti",
    "Continue subscription": "Pratęsti prenumeratą",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Nepavyko prijungti. Prisijungimo nuoroda nebegalioja.",
    "Could not update email! Invalid link.": "Nepavyko atnaujinti el. pašto adreso! Negaliojanti nuoroda.",
    "Create a new contact": "Sukurti naują kontaktą",
    "Current plan": "Dabartinis planas",
    "Delete account": "Ištrinti paskyrą",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Neplanavote to daryti? Galite keisti nustatymus <button>čia</button>.",
    "Don't have an account?": "Dar neturite paskyros?",
    "Edit": "Redaguoti",
    "Email": "El. paštas",
    "Email confirmation link expired.": "",
    "Email newsletter": "Naujienlaiškis el. paštu",
    "Email newsletter settings updated": "",
    "Email preferences": "El. pašto nustatymai",
    "Email preferences updated.": "",
    "Emails": "Laiškai",
    "Emails disabled": "El. laiškai deaktyvuoti",
    "Ends {offerEndDate}": "Baigiasi {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Klaida",
    "Expires {expiryDate}": "Nustoja galioti {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "Forever": "Neribotam laikui",
    "Free Trial – Ends {trialEnd}": "Nemokamas bandomasis laikotarpis – Baigiasi {trialEnd}",
    "Get help": "Gauti pagalbos",
    "Get in touch for help": "Susisiekti dėl pagalbos",
    "Get notified when someone replies to your comment": "Gaukite pranešimą, kai kas nors atsakys į jūsų komentarą",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Įvertinkite šį straipsnį",
    "Help! I'm not receiving emails": "Pagalbos! Negaunu el. laiškų",
    "Here are a few other sites you may enjoy.": "Tai keletas kitų svetainių, kurios jums gali patikti.",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Jei naujienlaiškis pažymėtas kaip šlamštas, el. laiškai automatiškai išjungiami tam el. pašto adresui, siekiant užtikrinti, kad nebegautumėte jokių nepageidaujamų pranešimų.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Jei el. laiškus kaip šlamštą pažymėjote netyčia arba norite vėl juos gauti, galite iš naujo prenumeruoti naujienlaiškį spustelėdami mygtuką ankstesniame ekrane.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Jei prenumeratą nutrauksite dabar, vis dar galėsite ja naudotis iki {periodEnd}",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Jei turite įmonės ar vyriausybės el. pašto paskyrą, susisiekite su IT skyriumi ir paprašykite leisti gauti el. laiškus iš {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Prisijungimo nuoroda buvo išsiųsta į jūsų el. pašto dėžutę. Jei laiškas neatkeliauja per 3 minutes, patikrinkite šlamšto (spam) aplanką.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Jei norite vėl gauti el. laiškus, būtų geriausia patikrinti įvestą el. pašto adresą ir ankstesniame ekrane spustelėti prenumeruoti.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Jei negaunate el. paštu naujienlaiškio, kurį užsiprenumeravote, štai keli dalykai, kuriuos reikia patikrinti.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Jei atlikote visas šias patikras ir vis tiek negaunate el. laiškų, bandykite kreiptis pagalbos: {supportAddress}",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Jei nuolatos nepavyks išsiųsti naujienlaiškio, siuntimas šiai paskyrai bus išjungtas",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "El. pašto programoje pridėkite {senderEmail} į savo kontaktų sąrašą. Tai parodys jūsų el. pašto paslaugų teikėjui, kad šiuo adresu siunčiami el. laiškai turėtų būti patikimi.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Mažiau tokių, kaip šis",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Įsitikinkite, kad el. laiškai netyčia nepatenka į pašto dėžutės aplankus „Šlamštas“ arba „Reklamos“. Jei taip įvyko, spustelėkite \"Žymėti kaip ne šlamštą\" ir (arba) \"Perkelti į gautuosius\".",
    "Manage": "Tvarkyti",
    "Maybe later": "Galbūt vėliau",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Narystės negalimos, susisiekite su savininku dėl prieigos.",
    "month": "",
    "Monthly": "Mėnesinis",
    "More like this": "Daugiau tokių, kaip šis",
    "More options": "",
    "Name": "Vardas",
    "Need more help? Contact support": "Reikia daugiau pagalbos? Susisiekite",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Naujienlaiškiai gali būti išjungti paskyroje dėl dviejų priežasčių: ankstesnis el. laiškas buvo pažymėtas kaip šlamštas arba bandymai išsiųsti el. laišką buvo nuolatos atmetami.",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Negaunate el. laiškų?",
    "Now check your email!": "Dabar patikrinkite savo el. paštą",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Jei užsiprenumeravę iš naujo nematote el. laiškų gautuosiuose, patikrinkite šlamšto aplanką. Kai kurie el. paslaugų teikėjai registruoja ankstesnius laiškų žymėjimus dėl šlamšto ir toliau juos žymi. Jei taip atsitiks, pažymėkite naujausią gautą laišką kaip „Ne šlamštą“, kad grąžintumėte jį į pagrindinių gautųjų sąrašą.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "Nuolatinis atmetimas",
    "Phone number": "",
    "Plan": "Planas",
    "Plan checkout was cancelled.": "Plano apmokėjimas buvo atšauktas.",
    "Plan upgrade was cancelled.": "Plano pagerinimas buvo atšauktas.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Prašome susisiekti {supportAddress}, norėdami koreguoti savo nemokamą prenumeratą.",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Užpildykite visus privalomus laukus",
    "Podcasts": "",
    "Re-enable emails": "Iš naujo įjungti el. laiškus",
    "Recommendations": "Rekomendacijos",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Atsinaujins už",
    "Resume subscription": "",
    "Retry": "Kartoti",
    "Save": "Išsaugoti",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send an email and say hi!": "Siųskite el. laišką ir pasisveikinkite!",
    "Send an email to {senderEmail} and say hello. This can also help signal to your mail provider that emails to and from this address should be trusted.": "Nusiųskite el. laišką adresu {senderEmail} ir pasisveikinkite. Tai taip pat gali padėti jūsų pašto paslaugų teikėjui pranešti, kad šiuo adresu siunčiami el. laiškai turėtų būti patikimi.",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Siunčiama prisijungimo nuoroda...",
    "Sending...": "Siunčiama...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "Rodyti viską",
    "Sign in": "Prisijungti",
    "Sign out": "Atsijungti",
    "Sign up": "Registruotis",
    "Signup error: Invalid link": "Registracijos klaida: negaliojanti nuoroda",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Atsiprašome, nepavyko.",
    "Spam complaints": "Skundai dėl šlamšto",
    "Start {amount}-day free trial": "Pradėti {amount}-dienų nemokamą bandomąją versiją",
    "Starting {startDate}": "Prasidės {startDate}",
    "Starting today": "Prasideda šiandien",
    "Submit feedback": "Pateikti atsiliepimą",
    "Subscribe": "Prenumeruoti",
    "Subscribed": "Užsiprenumeruota",
    "Subscription plan updated successfully": "",
    "Success": "Viskas pavyko",
    "Success! Check your email for magic link to sign-in.": "Viskas pavyko! Dabar savo el. pašto dėžutėje ieškokite specialios nuorodos prisijungimui. ",
    "Success! Your account is fully activated, you now have access to all content.": "Pavyko! Jūsų paskyra pilnai aktyvuota, nuo šiol turite prieigą prie specialaus turinio.",
    "Success! Your email is updated.": "Pavyko! Jūsų el. pašto adresas atnaujintas.",
    "Successfully unsubscribed": "Prenumerata sėkmingai atšaukta",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Ačiū, kad užsiprenumeravote. Prieš pradėdami skaityti, peržvelkite ir keletą kitų svetainių, kurios jums gali patikti.",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Ačiū už atsiliepimą!",
    "That didn't go to plan": "Kažkas nepavyko",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Nustatytas El. pašto adresas yra {memberEmail} – jei jis neteisingas, galite jį atnaujinti <button>paskyros nustatymuose</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Pateikiant atsiliepimą iškilo problema. Bandykite dar kartą vėliau.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "Ši svetainė pasiekiama tik su pakvietimu, susisiekite su savininku dėl prieigos. ",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Jei norite užbaigti registraciją, gautame el. laiške spustelėkite patvirtinimo nuorodą. Jei laiško negaunate per 3 minutes, patikrinkite šlamšto (spam) aplanką!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Išbandykite {amount} d. nemokamai, vėliau {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Gaukite prieigą prie visų naujienlaiškių įsigiję mokamą prenumeratą.",
    "Unsubscribe from all emails": "Atšaukti visas laiškų prenumeratas.",
    "Unsubscribed": "Nebeprenumeruojama",
    "Unsubscribed from all emails.": "Atšauktos visų laiškų prenumeratos.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Naujienlaiškio prenumeratos atšaukimas nenutrauks jūsų įsigytos mokamos {title} prenumeratos",
    "Update": "Atnaujinti",
    "Update your preferences": "Atnaujinti nustatymus",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Patvirtinimo nuoroda išsiųsta, patikrinkite savo el. pašto dėžutę",
    "Verify your email address is correct": "Įsitikinkite, jog jūsų el pašto adresas yra teisingas",
    "Verifying...": "",
    "View plans": "Peržiūrėti planus",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Nepavyko atšaukti laiškų prenumeratos, nes nepavyko rasti jūsų el. pašto adreso sistemoje. Susisiekite su svetainės savininku. ",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "Sveiki sugrįžę, {name}!",
    "Welcome back!": "Sveiki sugrįžę!",
    "Welcome to {siteTitle}": "Sveiki apsilankę {siteTitle}",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Kai el. pašto dėžutė nepriima el. laiško, tai paprastai vadinama atmetimu. Daugeliu atvejų tai gali būti laikina. Tačiau kai kuriais atvejais atšauktas el. laiškas gali būti grąžintas kaip pasikartojantis gedimas, kai el. pašto adresas neteisingas arba neegzistuoja.",
    "Why has my email been disabled?": "Kodėl mano el. paštas buvo deaktyvuotas?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Metinis",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Jūsų narystė šiuo metu yra nemokama. Norėdami turėti pilną prieigą įsigykite mokamą prenumeratą.",
    "You have been successfully resubscribed": "Jūs sėkmingai atkūrėte prenumeratą",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Jūs šiuo metu negaunate el. laiškų",
    "You're not receiving emails": "Jūs negaunate el. laiškų",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Jūs šiuo metu negaunate el. laiškų, nes pažymėjote naujausią laišką kaip šlamštą arba dėl to, kad nepavyko išsiųsti pranešimų jūsų nurodytu el. pašto adresu.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Sėkmingai prisijungėte.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Sėkmingai užsiprenumeravote <strong>{siteTitle}</strong>",
    "Your account": "Jūsų paskyra",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Jūsų indėlis padeda kurti tai, kas yra viešinama.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Jūsų prenumerata baigsis {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Jūsų prenumerata atsinaujins {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Jūsų prenumerata prasidės {subscriptionStart}"
}
